<template>
  <div
    v-loading="isDataLoading"
    class="offers-categories"
  >
    <UiConfirm
      ref="confirm"
      :width="480"
      :type="confirmType"
      :action-name="actionName"
      :action="confirmAction"
      :action-icon="actionIcon"
      :action-fa-icon="actionFaIcon"
      :has-close-btn="confirmAction !== 'deleteErrorCategory'"
      :confirm-filled="confirmAction !== 'deleteErrorCategory'"
      @save="onConfirm"
      @close="confirmClose"
    >
      <template v-slot:title>
        <div v-html="confirmTitle" />
      </template>
      <div class="body__wrap">
        <i
          v-if="confirmAction === 'deleteCategory'"
          :class="confirmType"
          class="fas fa-trash-alt t:mr-12"
        />
        <i
          v-if="confirmAction === 'deleteErrorCategory'"
          :class="confirmType"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <div
          v-if="confirmAction === 'deleteCategory' || confirmAction === 'deleteErrorCategory'"
          class="body__msg"
          v-html="confirmMsg"
        />
        <div
          v-else
          class="select-wrap offers-categories__full-width"
        >
          <UiInput
            v-model="category.name"
            :error="getError('name')"
            :placeholder="$t('affiliates.offersCategory.category_name_placeholder')"
            :label="$t('affiliates.offersCategory.category_name_label')"
            size="big"
            autosize
          />
        </div>
      </div>
    </UiConfirm>
    <div class="offers-categories__wrapper">
      <div class="offers-categories__info">
        <div class="offers-categories__sidebar">
          <div class="offers-categories__title-wrapper t:mb-16">
            <div class="offers-categories__title">
              {{ $t('affiliates.offersCategory.title') }}
            </div>
            <UiButton
              v-if="canEditCategory"
              icon="plus"
              @click="addCategoryHandler"
            >
              {{ $t('affiliates.offersCategory.add') }}
            </UiButton>
          </div>
          <div class="offers-categories__list">
            <RouterLink
              to="/affiliates/offers/all"
              class="offers-categories__link"
            >
              <div
                :class="{
                  'offers-categories__item--active': isActiveCategory === 'all',
                  'offers-categories__item--superuser': canEditCategory
                }"
                class="offers-categories__item offers-categories__item--main"
              >
                <div class="offers-categories__item-wrapper">
                  <h5 class="offers-categories__item-title">
                    {{ $t('affiliates.offersCategory.default_offer') }}
                  </h5>
                </div>
                <div
                  class="offers-categories__item-count"
                  :class="{'offers-categories__item-count--superuser': canEditCategory}"
                >
                  {{ allOffersCount }}
                  <UiIcon
                    name="list"
                    color="#a6b2c4"
                  />
                </div>
              </div>
            </RouterLink>
            <RouterLink
              v-for="(item, index) in dataCategories"
              :key="index"
              :to="`/affiliates/offers/${item.id}`"
              class="offers-categories__link"
            >
              <div
                :class="{
                  'offers-categories__item--active': isActiveCategory === item.id,
                  'offers-categories__item--superuser': canEditCategory
                }"
                class="offers-categories__item"
                @click="isActiveCategory = item.id"
              >
                <div class="offers-categories__item-wrapper">
                  <h5 class="offers-categories__item-title">
                    {{ item.name }}
                  </h5>
                </div>
                <div class="offers-categories__item-count">
                  {{ item.cataloged_affiliate_offers_count }}
                  <UiIcon
                    name="list"
                    color="#a6b2c4"
                  />
                </div>
                <div
                  v-if="canEditCategory"
                  class="offers-categories__item-actions"
                >
                  <span
                    class="offers-categories__action"
                    @click="editCategoryHandler(item)"
                  >
                    <UiIcon
                      name="pen"
                      color="var(--text-primary)"
                    />
                  </span>
                  <span
                    class="offers-categories__action"
                    @click="deleteCategoryHandler(item)"
                  >
                    <UiIcon
                      name="trash-alt"
                      color="var(--text-negative)"
                    />
                  </span>
                </div>
              </div>
            </RouterLink>
          </div>
        </div>
        <RouterView
          v-model:category="activeCategory"
          class="offers-categories__view"
          @refresh="refresh"
          @open-delete="deleteCategoryHandler(activeCategory)"
          @open-edit="editCategoryHandler(activeCategory)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import errorHandleMixin from '@/views/mixins/error-hadle';

export default {
  mixins: [errorHandleMixin],
  data() {
    return {
      isDataLoading: false,
      isActiveCategory: '',
      // isConfirmOpen: false,
      searchQuery: '',
      options: {
        search: '',
      },

      errors: {},
      dataCategories: [],
      allOffersCount: 0,
      category: {
        id: '',
        name: '',
      },

      confirmMsg: '',
      confirmAction: '',
      confirmTitle: '',
      confirmType: '',
      actionName: '',
      actionFaIcon: '',
      actionIcon: '',
    };
  },

  computed: {
    isSuperUser() {
      return this.$store.getters['auth/adminAcl'].is_superuser;
    },
    canEditCategory() {
      return this.isSuperUser;
    },
    activeCategory: {
      get() {
        return this.dataCategories ? this.dataCategories.find((item) => this.isActiveCategory === item.id) : {};
      },
      set(newValue) {
        this.activeCategory.name = newValue.name;
      },
    },
  },
  watch: {
    $route() {
      this.chooseCategory();
    },
    searchQuery() {
      this.options.search = this.searchQuery;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.$api.getAffiliateOffersCatalogCount().then((res) => {
        this.allOffersCount = res.data.payload.count;
      });
      this.getCategories();
      this.chooseCategory();
    },
    _query() {
      const _paramsFilter = {
        ...this.options,
      };
      return _paramsFilter;
    },

    chooseCategory() {
      this.isActiveCategory = this.$route.params.id;
      if (!this.isActiveCategory) {
        this.isActiveCategory = 'all';
      }
    },

    async getCategories() {
      this.isDataLoading = true;
      this.errors = {};
      try {
        const response = await this.$api.getAffiliateOffersCatalogCategories(this._query());
        this.dataCategories = this.$_.cloneDeep(response.data.payload);
      } catch (error) {
        this.errors = this.$_.cloneDeepWith(error.data.errors);
      } finally {
        this.isDataLoading = false;
      }
    },

    onConfirm() {
      // this.isConfirmOpen = false;
      switch (this.confirmAction) {
      case 'addCategory':
        this.addCategory();
        break;
      case 'editCategory':
        this.editCategory();
        break;
      case 'deleteCategory':
        this.deleteCategory();
        this.$refs.confirm.close();
        break;
      case 'deleteErrorCategory':
        this.$refs.confirm.close();
        break;
      default:
        break;
      }
    },

    addCategoryHandler() {
      this.confirmAction = 'addCategory';
      this.actionName = `${this.$t('affiliates.offersCategory.add_category_button')}`;
      this.confirmTitle = `${this.$t('affiliates.offersCategory.add_category_button')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'plus';
      this.$refs.confirm.open();
    },

    addCategory() {
      this.isDataLoading = true;
      this.errors = {};

      this.$api
        .postAffiliateOffersCatalogCategories({ name: this.category.name })
        .then(() => {
          this.getCategories();
          this.$refs.confirm.close();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },

    editCategoryHandler(category) {
      this.confirmAction = 'editCategory';
      this.actionName = `${this.$t('crm.buttons.save')}`;
      this.confirmTitle = `${this.$t('affiliates.offersCategory.edit_category_button')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'check';
      this.category.name = category.name;
      this.category.id = category.id;
      this.$refs.confirm.open();
    },
    editCategory() {
      this.$api
        .putAffiliateOffersCatalogCategories(this.category.id, { name: this.category.name })
        .then((res) => {
          this.activeCategory = this.$_.cloneDeepWith(res.data.payload);
          this.category.name = '';
          this.category.id = '';
          this.$refs.confirm.close();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },

    deleteCategoryHandler(category) {
      if (category.cataloged_affiliate_offers_count > 0) {
        this.confirmAction = 'deleteErrorCategory';
        this.confirmTitle = this.$t('affiliates.offersCategory.delete_category_title', { name: category.name });
        this.confirmMsg = this.$t('affiliates.offersCategory.delete_error_category_msg');
        this.confirmType = 'warning';
        this.actionName = this.$t('affiliates.cardView.toolbar.btns.close');
        this.actionFaIcon = 'times';
      } else {
        this.confirmAction = 'deleteCategory';
        this.confirmTitle = this.$t('affiliates.offersCategory.delete_category_title', { name: category.name });
        this.confirmMsg = this.$t('affiliates.offersCategory.delete_category_msg', { name: category.name });
        this.actionName = this.$t('affiliates.offersCategory.delete_category_action');
        this.confirmType = 'warning';
        this.actionFaIcon = 'trash-alt';
      }
      this.category.id = category.id;
      this.$refs.confirm.open();
    },
    deleteCategory() {
      const categoryId = this.category.id;
      this.$api
        .deleteAffiliateOffersCatalogCategories(categoryId)
        .then(() => {
          if (this.isActiveCategory === categoryId) {
            this.$router.push('/affiliates/offers/all');
            this.isActiveCategory = 'all';
          }

          this.getCategories();
          this.category.name = '';
          this.category.id = '';
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },

    confirmClose() {
      this.actionIcon = '';
      this.actionFaIcon = '';
      this.category.name = '';
      this.category.id = '';
    },

    refresh() {
      this.initData();
    },
  },
};
</script>
